import React, { useEffect, useState, useContext, useRef } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import {
  InputBase,
  IconButton,
  Snackbar,
  Alert,
  CircularProgress,
  Tooltip,
  Autocomplete,
  Backdrop
} from "@mui/material";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../../context";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useSnackbar } from "notistack";
//icons
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import KeyboardVoiceOutlinedIcon from "@mui/icons-material/KeyboardVoiceOutlined";
import MicIcon from "@mui/icons-material/Mic";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import dayjs from "dayjs";
import MenuItem from "@mui/material/MenuItem";
import { genderOptions } from "../ClinicalNotesAPI/DropdownData";
import {
  Add,
  ArrowForward,
  Close,
  HelpOutline,
  InfoOutlined,
} from "@mui/icons-material";
import { useAuth } from "../../../../auth";
import sign from "jwt-encode";
import jwtDecode from "jwt-decode";
import {
  getUsage,
  handleBrokenImage,
  isAusDomain,
  updateUsageTracker,
} from "../lib/utils";
import NewTranscriptionDialog from "./NewTranscriptionDialog";
import Cookies from "js-cookie";
import { countriesJSON } from "../../lib/utils";
import SubscriptionAlertModal from "../../modals/SubscriptionAlertModal";
import { trackClinicalNoteCreation, trackClinicalNoteSelectPatient } from "../../../../utils/analytics";

const CreateClinicalNote = ({
  setClinicalNotesState,
  setAppointmentIDfromAPI,
  fetchClinicalNotesList,
  setNoteType,
  top,
  clientsList,
}) => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const { expertDetails } = useContext(AppContext);

  const isAskSam = isAusDomain();

  const [open, setOpen] = useState(false);
  const [createNewClient, setCreateNewClient] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [searchedData, setSearchedData] = useState([]);
  const [storedClientList, setStoredClientList] = useState([]);
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);

  const [countryList, setCountryList] = useState();
  const [stateList, setStateList] = useState();
  const [responseData, setResponseData] = useState();
  const [errorMessage, setErrorMessage] = useState("");

  const [subscriptionModal, setSubscriptionModal] = useState(false);
  const [clientDetails, setClientDetails] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    email: "",
    phone: "",
    phone_code: isAusDomain() ? "+61-AU" : "", // Default to Australia if Australian domain
    age: "",
    sex: "",
    hisNumber: "",
    address: "",
    socialSecurity: "",
    country: currentUser?.Country || "",
    consultation: dayjs().format("YYYY-MM-DD"),
    state: "",
    dob: "",
    time_zone: "",
  });

  const [countrySearchTerm, setCountrySearchTerm] = useState("");
  const [isCountryDropdownOpen, setIsCountryDropdownOpen] = useState(false);
  const countryDropdownRef = useRef(null);
  const [selectPatientDetails, setSelectPatientDetails] = useState(null)
  const getPhoneCodeFromValue = (value) => {
    return value?.split("-")[0] || "+61";
  };

  // Filter countries based on search term
  const getFilteredCountries = () => {
    if (!countrySearchTerm.trim()) {
      return countriesJSON?.sort((a, b) => a.name.localeCompare(b.name)) || [];
    }

    const searchLower = countrySearchTerm.toLowerCase();
    return (
      countriesJSON
        ?.filter(
          (country) =>
            country.name.toLowerCase().includes(searchLower) ||
            country.phone_code.toLowerCase().includes(searchLower) ||
            country.iso2.toLowerCase().includes(searchLower)
        )
        ?.sort((a, b) => a.name.localeCompare(b.name)) || []
    );
  };

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        countryDropdownRef.current &&
        !countryDropdownRef.current.contains(event.target)
      ) {
        setIsCountryDropdownOpen(false);
      }
    };

    if (isCountryDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isCountryDropdownOpen]);



  const [noteDetails, setNoteDetails] = useState(null);
  const [showOptionalFields, setShowOptionalFields] = useState(false);
  const [TranscriptionDialog, setTranscriptionDialog] = useState(false);
  const [timezone, setTimezone] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const [currentPlan, setCurrentPlan] = useState(false);

  // Set default phone code for Australian domains
  useEffect(() => {
    if (isAusDomain()) {
      setClientDetails(prev => ({
        ...prev,
        phone_code: "+61-AU"
      }));
    }
  }, []); // Run once on mount

  // Get Country List
  useEffect(() => {
    const storedData = localStorage.getItem("Authorization");
    const token = storedData ? storedData.split("Bearer ")[1] : null;
    const fetchData = async () => {
      // setLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_EXPERT_BASE_URL}static/countries`,
          {
            method: "GET",
            headers: {
              "X-API-Key": process.env.REACT_APP_EXPERT_API_KEY,
              "Content-Type": "application/json",
              token: token,
              authenticationToken: Cookies.get("authDataJwt"),
            },
          }
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const jsonData = await response.json();
        setCountryList(jsonData?.countries);
      } catch (error) {
        setError(error);
      } finally {
        // setLoading(false);
      }
    };

    fetchData();
    postClientsData();
  }, []);

  // Fetch plans when country and user data are available
  useEffect(() => {
    if (
      expertDetails?.profile?.country &&
      (currentUser?.UserId || localStorage.getItem("profile"))
    ) {
      fetchPlans();
    }
  }, [expertDetails?.profile?.country, currentUser?.UserId]);

  // Get State List
  useEffect(() => {
    const storedData = localStorage.getItem("Authorization");
    const token = storedData ? storedData.split("Bearer ")[1] : null;
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_EXPERT_BASE_URL}static/states?country=${clientDetails?.country}`,
          {
            method: "GET",
            headers: {
              "X-API-Key": process.env.REACT_APP_EXPERT_API_KEY,
              "Content-Type": "application/json",
              Authorization: token,
              authenticationToken: Cookies.get("authDataJwt"),
            },
          }
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const jsonData = await response.json();

        setStateList(jsonData?.states);
      } catch (error) {
        setError(error);
        setErrorMessage(true);
      } finally {
        setLoading(false);
      }
    };

    if (clientDetails?.country) {
      fetchData(); // Fetch data only when clientDetails.country is defined
    }
  }, [clientDetails?.country]);

  // Search client
  useEffect(() => {
    const storedData = localStorage.getItem("Authorization");
    const token = storedData ? storedData.split("Bearer ")[1] : null;

    // Debounce timer
    const debounceTimer = setTimeout(() => {
      if (inputValue?.trim() === "") {
        setSearchedData(storedClientList);
        return;
      }
      var emailPattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
      if (!emailPattern.test(inputValue)) {
        return;
      }

      const fetchData = async () => {
        setLoading(true);
        try {
          const response = await fetch(
            `${process.env.REACT_APP_EXPERT_BASE_URL}jwt-clinicalnotes/search-clients?search=${inputValue}`,
            {
              method: "GET",
              headers: {
                "X-API-Key": `${process.env.REACT_APP_EXPERT_API_KEY}`,
                "Content-Type": "application/json",
                token: token,
                authenticationToken: Cookies.get("authDataJwt"),
              },
            }
          );
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          const jsonData = await response.json();

          setSearchedData(jwtDecode(jsonData?.data));
        } catch (error) {
          setError(error);
        } finally {
          setLoading(false);
        }
      };

      fetchData();
    }, 500); // 500 ms debounce time

    return () => {
      clearTimeout(debounceTimer);
    };
  }, [inputValue, storedClientList]);

  // Get Timezone List
  // ... existing code ...
  useEffect(() => {
    const fetchTimezone = () => {
      if (clientDetails?.country) {
        try {
          const countryData = countriesJSON?.find(
            (country) => country.name === clientDetails?.country // Changed from currentUser?.Country
          );
          if (countryData?.timezones?.length > 0) {
            const firstTimezone = countryData.timezones[0].zoneName;
            setTimezone(firstTimezone);
          }
        } catch (error) {
          console.error("Error setting timezone:", error);
        }
      }
    };
    fetchTimezone();
  }, [clientDetails?.country]);



  const postClientsData = async (retryCount = 0) => {
    const storedData = localStorage.getItem("Authorization");
    const token = storedData ? storedData?.split("Bearer ")[1] : null;
    const headers = {
      "X-API-Key": process.env.REACT_APP_EXPERT_API_KEY,
      "Content-Type": "application/json",
      token: token,
      authenticationToken: Cookies.get("authDataJwt"),
    };
    try {
      // Add cache-busting parameter to ensure fresh data
      const cacheBuster = Date.now();
      const response = await fetch(
        `${process.env.REACT_APP_EXPERT_BASE_URL}jwt-clinicalnotes/list-clients?professional_id=${currentUser?.UserId}&count=200&_t=${cacheBuster}`,
        {
          method: "GET",
          headers,
        }
      );
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.status}`);
      }
      const postResponse = await response.json();

      if (!postResponse.data) {
        throw new Error("No data received from API");
      }

      const clients = await postResponse.data;
      const decodedClients = jwtDecode(clients);

      // Validate decoded data
      if (!Array.isArray(decodedClients)) {
        throw new Error("Invalid client data format");
      }

      setSearchedData(decodedClients);
      setStoredClientList(decodedClients);


      setLoading(false);
    } catch (error) {
      console.error("Error fetching clients:", error);

      // Retry logic for failed requests
      if (retryCount < 2) {

        setTimeout(() => postClientsData(retryCount + 1), 1000);
        return;
      }

      // Show error to user after all retries failed
      enqueueSnackbar("Failed to load patient list. Please refresh the page.", {
        variant: "error",
      });
      setLoading(false);
    }
  };

  const handleChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleClickOpen = async () => {
    const profileData = JSON.parse(localStorage.getItem("profile")); // Parse profileData if it's stored as a string

    const cred = sign(
      { user_id: `${profileData?.UserId}` },
      process.env.REACT_APP_JWT_ENCODE_SECRET || ""
    );
    // Usage limits apply to all users (like AUS system)
    const usage = await getUsage("clinical_notes", profileData?.UserId, cred);
    if (!usage.success) return;
    if (!usage?.data?.value) {
      // enqueueSnackbar("Usage Limit Exhausted", { variant: "warning" })
      setSubscriptionModal(true);
      return;
    }

    // Only refresh client list if it's empty or hasn't been loaded recently
    if (storedClientList?.length === 0 || !storedClientList) {
      await postClientsData();
    }

    // Clear any previous search input
    setInputValue("");

    if (storedClientList?.length > 0) {
      setOpen(true);
    } else {
      setCreateNewClient(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };
  const fetchPlans = async () => {
    try {
      // Use context country data with fallback to localStorage
      const country = expertDetails?.profile?.country;
      let userId;

      // Try multiple sources for userId
      try {
        const profileData = JSON.parse(localStorage.getItem("profile"));
        userId = currentUser?.UserId || profileData?.UserId;
      } catch (e) {
        console.error("Error parsing profile data:", e);
        return;
      }

      if (!country || !userId) {
        console.error("Missing required data:", {
          country,
          userId,
          expertDetailsLoaded: !!expertDetails?.profile,
          currentUserLoaded: !!currentUser?.UserId,
        });
        return;
      }

      const response = await fetch(
        `https://us.uwc.world//new-uwc/subscription/plans/list?country=${encodeURIComponent(
          country
        )}&user_id=${userId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "X-API-Key": "76d802e426a2cb28f3760c8c8f669983f67ed775",
          },
        }
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const resp = await response.json();
      if (resp.success) {
        setCurrentPlan(
          resp.data.subscription_plans?.find((p) => p?.is_current_plan)
        );
      }
    } catch (error) {
      console.error("Error fetching plans:", error);
    }
  };

  const handleProfileClick = async (data) => {
    // setLoading(true);
    try {
      // Store the current patient data before creating clinical note
      const currentPatientData = data;
      const profileData = JSON.parse(localStorage.getItem("profile"));

      setSelectPatientDetails(data)

      // Track patient selection event
      await trackClinicalNoteSelectPatient(profileData?.UserId, data?.user_id);

      // Create clinical note for existing patient
      await createClinicalNoteEventForExistingPatient(currentPatientData, false);

    } catch (error) {
      console.error("Error creating clinical note for existing patient:", error);
      enqueueSnackbar("Failed to create clinical note. Please try again.", {
        variant: "error",
      });
      setLoading(false);
    }
  };

  // Create Clinical user then create session
  const confirmAndCreateSession = async () => {
    setLoading(true);

    // Retrieve the token from localStorage
    const storedData = localStorage.getItem("Authorization");
    const token = storedData ? storedData.split("Bearer ")[1] : null;

    // Input validation - either email or phone must be provided
    const hasEmail = clientDetails?.email && clientDetails?.email.trim() !== "";
    const hasPhone = clientDetails?.phone && clientDetails?.phone.trim() !== "";

    if (!hasEmail && !hasPhone) {
      enqueueSnackbar("Please enter either Email Address or Phone Number", {
        variant: "error",
      });
      setLoading(false);
      return;
    }

    // Validate email if provided
    if (hasEmail) {
      const emailPattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
      if (!emailPattern.test(clientDetails.email)) {
        enqueueSnackbar("Please enter a Valid Email Address", {
          variant: "error",
        });
        setLoading(false);
        return;
      }
    }

    // Validate phone if provided
    /*if (hasPhone) {
      const phoneDigits = clientDetails.phone.replace(/\D/g, ""); // Remove non-digit characters
      if (phoneDigits.length !== 10) {
        enqueueSnackbar("Please enter a valid 10-digit Phone Number", {
          variant: "error",
        });
        setLoading(false);
        return;
      }
    }*/

    // Construct the body payload

    // Format phone number with country code
    let formattedPhone = clientDetails?.phone;
    if (clientDetails?.phone_code) {
      formattedPhone = clientDetails.phone_code.split("-")[0] + clientDetails?.phone;
    } else if (isAusDomain() && clientDetails?.phone) {
      formattedPhone = "+61" + clientDetails?.phone; // Default for Australian domains
    }

    // Extract phone country code from phone_code field (format: "+61-AU" -> "+61")
    // Add fallback for Australian domains if phone_code is empty
    let phoneCountryCode = "";
    // console.log("clientDetails", clientDetails)
    if (clientDetails?.phone_code) {
      phoneCountryCode = clientDetails.phone_code.split("-")[0];
    } else if (isAusDomain()) {
      phoneCountryCode = "+61"; // Default for Australian domains
    }



    const body = {
      firstName: clientDetails?.firstName,
      middleName: clientDetails?.middleName,
      lastName: clientDetails?.lastName,
      name: `${clientDetails?.firstName} ${clientDetails?.middleName} ${clientDetails?.lastName}`,
      email: clientDetails?.email,
      phone: formattedPhone,
      age: clientDetails?.age,
      dob: dayjs(clientDetails?.dob).format("YYYY-MM-DD").toString(),
      gender: clientDetails?.sex,
      address: {
        address_line: clientDetails?.address,
        state: clientDetails?.state,
        country: clientDetails?.country,
      },
      platform: "CCOP",
      his_number: clientDetails?.hisNumber,
      social_security_number: clientDetails?.socialSecurity,
      session_date: dayjs(clientDetails?.consultation)
        .format("YYYY-MM-DD")
        .toString(),

      country: clientDetails?.country,
      country_code: phoneCountryCode,
      time_zone: timezone?.length > 0 ? timezone : "",
      created_by: currentUser?.UserId.toString(),
      region: isAskSam ? "australia" : "global",
    };



    try {
      const response = await fetch(
        `${process.env.REACT_APP_CAUTH_URL}users/register/patient`,
        {
          method: "POST",
          headers: {
            "X-API-Key": `${process.env.REACT_APP_CAUTH_X_API_KEY}`,
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // Add token if required by the API
          },
          body: JSON.stringify(body),
        }
      );

      // Parse response
      const jsonData = await response.json();

      if (jsonData.status === 200 || jsonData.status === 201) {
        const resp = jsonData.data; // Assuming the response contains a JWT token
        const profileData = JSON.parse(localStorage.getItem("profile"));
        setResponseData(resp);
        
        // Track patient selection event for new patient
        await trackClinicalNoteSelectPatient(profileData?.UserId, resp?.user_id);
        
        createClinicalNoteEvent(resp); // Perform necessary follow-up actions
      } else {

        enqueueSnackbar(
          jsonData?.message || "An error occurred during registration",
          { variant: "error" }
        );
        return;
      }
    } catch (error) {
      console.error("Request Error:", error);
      enqueueSnackbar("Failed to register user. Please try again.", {
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  // Create clinical Note session for existing patient (no patient list refresh)
  const createClinicalNoteEventForExistingPatient = async (patientData, createClinicalNote) => {
    // setLoading(true);
    setTranscriptionDialog(true);
    if (createClinicalNote) {
      try {
        const storedData = localStorage.getItem("Authorization");
        const profileData = JSON.parse(localStorage.getItem("profile"));
        const token = storedData ? storedData.split("Bearer ")[1] : null;
        const expertId = String(profileData?.UserId);
        const expertType = String(profileData?.UserType);
        const userId = String(patientData?.user_id);

        const payload = sign(
          {
            client: {
              user_id: userId,
              name: patientData?.name || "default",
              email: patientData?.email || "",
              phone: patientData?.phone || "",
              his_number: patientData?.his_number || "",
              image: patientData?.image || "",
            },
            session_type: "Follow-up",
            session_date: dayjs().format("YYYY-MM-DD"),
            expert: {
              user_id: expertId,
              name: profileData?.Name,
              email: profileData?.Emailid,
              phone: profileData?.MobileNo,
              image: profileData?.ProfileImage,
              expert_type: expertType,
            },
          },
          process.env.REACT_APP_JWT_SECRET
        );

        const body = JSON.stringify({ data: payload });

        const response = await fetch(
          `${process.env.REACT_APP_EXPERT_BASE_URL}jwt-clinicalnotes/create`,
          {
            method: "POST",
            headers: {
              "X-API-Key": process.env.REACT_APP_EXPERT_API_KEY,
              "Content-Type": "application/json",
              Token: token,
              authenticationToken: Cookies.get("authDataJwt"),
            },
            body: body,
          }
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        if (response.status === 201) {
          const jsonData = await response.json();

          // Close the dialog
          setOpen(false);

          // Update usage tracker
          const cred = sign(
            { user_id: `${profileData?.UserId}` },
            process.env.REACT_APP_JWT_ENCODE_SECRET || ""
          );
          await updateUsageTracker("clinical_notes", profileData?.UserId, cred);

          // Track clinical note creation event - send immediately before any navigation
          await trackClinicalNoteCreation(profileData?.UserId);

          const newData = jwtDecode(jsonData?.data);
          setAppointmentIDfromAPI(newData?._id);
          setNoteDetails(newData);
          setTranscriptionDialog(true);

          // Refresh clinical notes list only (not patient list to avoid disappearing)
          if (fetchClinicalNotesList) {
            setTimeout(() => {
              fetchClinicalNotesList();
            }, 500);
          }


        }
      } catch (error) {
        console.error("Error creating clinical note for existing patient:", error);
        enqueueSnackbar("Failed to create clinical note. Please try again.", {
          variant: "error",
        });
      } finally {
        setLoading(false);
      }
    }

  };

  // Create clinical Note session for new patient (includes patient list refresh)
  const createClinicalNoteEvent = async (responseData) => {
    setLoading(true);

    try {
      const storedData = localStorage.getItem("Authorization");
      const profileData = JSON.parse(localStorage.getItem("profile")); // Parse profileData if it's stored as a string
      const token = storedData ? storedData.split("Bearer ")[1] : null;
      const expertId = String(profileData?.UserId);
      const expertType = String(profileData?.UserType);
      const userId = String(responseData?.user_id);

      const payload = sign(
        {
          client: {
            user_id: userId,
            name:
              responseData?.user_details?.name ||
              responseData?.name ||
              "default",
            email: responseData?.user_details?.email || clientDetails?.email,
            phone:
              responseData?.user_details?.phone ||
              (clientDetails?.phone_code
                ? clientDetails.phone_code.split("-")[0] + clientDetails?.phone
                : clientDetails?.phone) || "",
            his_number: responseData?.his_number || "",
            image: responseData?.user_details?.image || "",
          },
          session_type: "Follow-up",
          session_date: dayjs().format("YYYY-MM-DD"),
          expert: {
            user_id: expertId,
            name: profileData?.Name,
            email: profileData?.Emailid,
            phone: profileData?.MobileNo,
            image: profileData?.ProfileImage,
            expert_type: expertType,
          },
        },
        process.env.REACT_APP_JWT_SECRET
      );


      const body = JSON.stringify({ data: payload });

      const response = await fetch(
        `${process.env.REACT_APP_EXPERT_BASE_URL}jwt-clinicalnotes/create`,
        {
          method: "POST",
          headers: {
            "X-API-Key": process.env.REACT_APP_EXPERT_API_KEY,
            "Content-Type": "application/json",
            Token: token,
            authenticationToken: Cookies.get("authDataJwt"),
          },
          body: body, // Serialize body object to JSON
        }
      );



      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      if (response.status === 201) {
        const jsonData = await response.json();



        // Reset form and close dialogs
        setCreateNewClient(false);
        setOpen(false);

        // Reset client details form
        setClientDetails({
          firstName: "",
          middleName: "",
          lastName: "",
          email: "",
          phone: "",
          phone_code: isAusDomain() ? "+61-AU" : "",
          age: "",
          sex: "",
          hisNumber: "",
          address: "",
          socialSecurity: "",
          country: currentUser?.Country || "",
          consultation: dayjs().format("YYYY-MM-DD"),
          state: "",
          dob: "",
          time_zone: "",
        });
        setCountrySearchTerm("");
        setIsCountryDropdownOpen(false);

        // Add delay before refreshing to ensure server has processed the new patient
        setTimeout(async () => {
          try {
            // Refresh the client list to show the newly created patient
            await postClientsData();

            // Also refresh the clinical notes list if available
            if (fetchClinicalNotesList) {
              await fetchClinicalNotesList();
            }


          } catch (error) {
            console.error("Error refreshing patient lists:", error);
            enqueueSnackbar("Patient created successfully, but list refresh failed. Please refresh the page.", {
              variant: "warning",
            });
          }
        }, 1500); // 1.5 second delay to allow server processing

        const cred = sign(
          { user_id: `${profileData?.UserId}` },
          process.env.REACT_APP_JWT_ENCODE_SECRET || ""
        );
        // Update usage tracker for all users (like AUS system)
        const updateUsage = await updateUsageTracker(
          "clinical_notes",
          profileData?.UserId,
          cred
        );

        // Track clinical note creation event - send immediately before any navigation
        await trackClinicalNoteCreation(profileData?.UserId);

        const newData = jwtDecode(jsonData?.data);
        // setAppointmentIDfromAPI(newData?._id);
        // setNoteType(newData?.session_type)
        // setLoading(false);
        // setClinicalNotesState({ view: "view" });
        setNoteDetails(newData);
        
        // Track newly created note in sessionStorage for save and exit tracking
        if (newData?._id) {
          try {
            const newlyCreatedNotes = JSON.parse(sessionStorage.getItem('newlyCreatedClinicalNotes') || '[]');
            if (!newlyCreatedNotes.includes(String(newData._id))) {
              newlyCreatedNotes.push(String(newData._id));
              sessionStorage.setItem('newlyCreatedClinicalNotes', JSON.stringify(newlyCreatedNotes));
            }
          } catch (error) {
            console.error("Error storing newly created note ID:", error);
          }
        }
        
        setTranscriptionDialog(true);
      }
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };



  // const handleConsultationDateChange = (date) => {
  //   const formattedDate = dayjs(date).format("YYYY-MM-DD");
  //   setClientDetails((prevData) => ({
  //     ...prevData,
  //     consultation: formattedDate,
  //   }));
  // };
  const handleConsultationDateChange = (date) => {
    const formattedDate = date.target.value;
    setClientDetails((prevData) => ({
      ...prevData,
      consultation: formattedDate,
    }));
  };
  const handleDobChange = (date) => {
    const formattedDate = date.target.value;
    setClientDetails((prevData) => ({
      ...prevData,
      dob: formattedDate,
      age: dayjs().diff(dayjs(date.target.value), "year"),
    }));
  };

  const handleGenderChange = (event) => {
    setClientDetails({
      ...clientDetails,
      sex: event.target.value,
    });
  };

  const handleCountryChange = (event) => {
    setClientDetails({
      ...clientDetails,
      country: event.target.value,
    });
  };



  const handleStateChange = (event) => {
    setClientDetails({
      ...clientDetails,
      state: event.target.value,
    });
  };



  return (
    <div className="ml-auto">
      <SubscriptionAlertModal
        h1={
          !currentPlan
            ? "Get Started with Clinical Copilot"
            : "Upgrade to Create More Clinical Notes"
        }
        h2={
          !currentPlan
            ? `Choose one of our plans to access Clinical Notes, Letter Templates, ${isAusDomain() ? "Ask Sam" : "United We Care"
            } Interactions, and much more.`
            : "You have exhausted all your credits for this month. To create more Clinical Notes, please upgrade to a better plan."
        }
        cta1={!currentPlan ? "Select Now" : "Upgrade Now"}
        cta2={!currentPlan ? "Select Later" : "Upgrade Later"}
        isOpen={subscriptionModal}
        onClose={() => setSubscriptionModal(false)}
      />
      <div
        role="button"
        style={{
          background: "var(--primary-color)",
          fontSize: "16px",
          width: "100%",
          opacity: "100",
          boxShadow: "0px 20px 50px 0px var(--primary-accent-color)",
        }}
        id="create_clinical_note"
        className={` d-flex align-items-center gap-2 fw-semibold  ${top ? "rounded rounded-2" : "rounded-pill"
          } text-white p-3 `}
        onClick={handleClickOpen}
      >
        <Add />
        <span
          className={storedClientList?.length > 0 ? "d-none d-sm-block" : "  "}
        >
          {storedClientList?.length > 0
            ? "Create Clinical Note"
            : "Create Your First Clinical Note "}
        </span>
      </div>
      <NewTranscriptionDialog
        onSuccess={() => {
          // setAppointmentIDfromAPI(noteDetails?._id);
          // setNoteType(noteDetails?.session_type);
          setClinicalNotesState({ view: "view" });
        }}
        data={noteDetails}
        open={TranscriptionDialog}
        handleClose={() => setTranscriptionDialog(false)}
        responseData={responseData}
        clientDetails={clientDetails}
        setSubscriptionModal={() => setSubscriptionModal(true)}
        setAppointmentIDfromAPI={setAppointmentIDfromAPI}
        setNoteType={setNoteType}
        setNoteDetails={setNoteDetails}
        patientData={selectPatientDetails}
        isCreate={true}
      />
      <Dialog
        className="client-details-dialog"
        open={open}
        onClose={handleClose}
        maxWidth="md"
      >
        <DialogTitle className="d-flex gap-2 align-items-center">
          <Paper
            component="form"
            sx={{
              p: "4px",
              display: "flex",
              alignItems: "center",
              width: "100%",
              borderRadius: "8px",
              margin: "10px 0",
            }}
            className=" shadow-none border border-2"
          >
            <InputBase
              id="search_clients"
              sx={{ ml: 1, flex: 1 }}
              placeholder={`Search by ${isAusDomain() ? "Patient" : "Client"
                }'s Name or Email`}
              value={inputValue}
              onChange={handleChange}
            />

          </Paper>
          <div className="d-md-none">
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent className="p-0 p-md-4">
          {searchedData?.length < 1 && inputValue?.trim() === "" && (
            <DialogContentText className="w-50 font-inter fw-semibold  text-center mx-auto my-4">
              Type a {isAusDomain() ? "patient" : "client"}'s name in the search
              bar to find existing clients quickly. Or, simply start typing to
              create a new {isAusDomain() ? "patient" : "client"} profile.
            </DialogContentText>
          )}
          {searchedData?.filter(
            (item, idx) =>
              item?.name?.toLowerCase().includes(inputValue.toLowerCase()) ||
              item?.email?.includes(inputValue)
          )?.length < 1 &&
            inputValue?.trim() !== "" && (
              <DialogContentText className="w-50 font-inter fw-semibold  text-center mx-auto my-4">
                No clients match your search criteria. To create a new{" "}
                {isAusDomain() ? "patient" : "client"} profile, use the button
                below.
              </DialogContentText>
            )}

          {searchedData?.length > 0 && (
            <div>
              <style>
                {`.client_profile:hover {
                background-color: var(--primary-accent-color);
                border-radius: 8px;
                border: 1px solid var(--primary-color-opacity50);
              }`}
              </style>
              <div>
                {searchedData
                  ?.filter(
                    (item, idx) =>
                      item?.name
                        ?.toLowerCase()
                        .includes(inputValue.toLowerCase()) ||
                      (item?.email && item.email.includes("@") && item?.email
                        ?.toLowerCase()
                        .includes(inputValue.toLowerCase()))
                  )
                  ?.map((data, index) => (
                    <div
                      key={index}
                      className="d-flex w-100 gap-2 p-2 align-items-center justify-content-between client_profile"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleProfileClick(data)}
                    >
                      <div className="d-flex gap-2">
                        <img
                          src={data?.image}
                          onError={(e) => {
                            const newLink = handleBrokenImage(data?.image);
                            e.target.src = newLink;
                          }}
                          alt=""
                          width={78}
                          height={78}
                          style={{ minWidth: "78px", minHeight: "78px" }}
                          className="rounded rounded-circle"
                        />{" "}
                        <div className="p-2 d-flex flex-column gap-2">
                          <p
                            style={{
                              color: "var(--Text-text-primary, #080807)",
                              fontFamily: "Roboto",
                              fontSize: "18px",
                              fontStyle: "normal",
                              fontWeight: 500,
                              lineHeight: "normal",
                              margin: "0px",
                            }}
                          >
                            {data?.name}
                          </p>
                          {!isAusDomain() && (
                            <p
                              style={{
                                color: "var(--Text-text-primary, #807C75)",
                                fontFamily: "Roboto",
                                fontSize: "14px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "normal",
                                margin: "0px",
                              }}
                            >
                              HIS Number:{" "}
                              <span
                                style={{
                                  color: "var(--Text-text-primary, #080807)",
                                  textTransform: "uppercase",
                                }}
                              >
                                {" "}
                                {data?.his_number}
                              </span>
                            </p>
                          )}
                          <div className="d-flex flex-column flex-lg-row gap-2">
                            <p
                              style={{
                                color: "var(--Text-text-primary, #807C75)",
                                fontFamily: "Roboto",
                                fontSize: "14px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "normal",
                                margin: "0px",
                              }}
                            >
                              <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.7695 1.66797H1.23047C0.552836 1.66797 0 2.2202 0 2.89844V11.1016C0 11.7775 0.550375 12.332 1.23047 12.332H12.7695C13.4455 12.332 14 11.7817 14 11.1016V2.89844C14 2.2225 13.4496 1.66797 12.7695 1.66797ZM12.5996 2.48828L7.02609 8.06184L1.40435 2.48828H12.5996ZM0.820312 10.9317V3.06439L4.77091 6.98111L0.820312 10.9317ZM1.40036 11.5117L5.35344 7.55863L6.73859 8.93189C6.89894 9.09087 7.15769 9.09035 7.31738 8.93063L8.66797 7.58004L12.5996 11.5117H1.40036ZM13.1797 10.9317L9.24801 7L13.1797 3.0683V10.9317Z"
                                  fill="#807C75"
                                />
                              </svg>{" "}
                              <span className="fw-semibold ">
                                {" "}
                                {data?.email && data.email.includes("@") ? data.email.substring(0, 25) : "-"}
                              </span>
                            </p>
                            <p
                              style={{
                                color: "var(--Text-text-primary, #807C75)",
                                fontFamily: "Roboto",
                                fontSize: "14px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "normal",
                                margin: "0px",
                              }}
                            >
                              <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_526_4013)">
                                  <path
                                    d="M2.85269 9.30626C4.23354 10.9569 5.89579 12.2565 7.79301 13.1761C8.51535 13.5184 9.48137 13.9246 10.5576 13.9942C10.6243 13.9971 10.6882 14 10.7549 14C11.4772 14 12.0574 13.7505 12.5303 13.237C12.5332 13.2341 12.539 13.2283 12.5419 13.2225C12.7101 13.0195 12.9016 12.8367 13.1018 12.6424C13.2381 12.5118 13.3773 12.3755 13.5108 12.2362C14.1287 11.5922 14.1287 10.7741 13.505 10.1504L11.7615 8.40696C11.4656 8.09946 11.1117 7.93701 10.7404 7.93701C10.3691 7.93701 10.0122 8.09946 9.70764 8.40406L8.6691 9.4426C8.57337 9.38748 8.47474 9.33817 8.38191 9.29175C8.26587 9.23373 8.15853 9.17862 8.0628 9.1177C7.11709 8.5172 6.25841 7.73394 5.43744 6.72731C5.0226 6.20224 4.74411 5.76129 4.54975 5.31165C4.82244 5.06506 5.07772 4.80688 5.3243 4.5545C5.41133 4.46457 5.50126 4.37464 5.59119 4.28471C5.90449 3.9714 6.07275 3.60879 6.07275 3.24036C6.07275 2.87194 5.90739 2.50932 5.59119 2.19602L4.72671 1.33154C4.62517 1.23 4.52944 1.13137 4.43081 1.02984C4.23935 0.832574 4.03918 0.629507 3.84191 0.446747C3.54312 0.15375 3.1921 0 2.82078 0C2.45236 0 2.09844 0.153751 1.78804 0.449648L0.703084 1.5346C0.308554 1.92913 0.0851809 2.40779 0.0387656 2.96187C-0.0163525 3.6552 0.111289 4.39204 0.441998 5.28264C0.949665 6.66059 1.71552 7.93991 2.85269 9.30626ZM0.746598 3.02279C0.78141 2.63697 0.929358 2.31496 1.20785 2.03647L2.287 0.957315C2.45526 0.794861 2.64092 0.710734 2.82078 0.710734C2.99774 0.710734 3.1776 0.794861 3.34295 0.963116C3.53731 1.14298 3.72008 1.33154 3.91734 1.5317C4.01597 1.63324 4.11751 1.73477 4.21904 1.8392L5.08352 2.70369C5.26338 2.88355 5.35621 3.06631 5.35621 3.24617C5.35621 3.42603 5.26338 3.60879 5.08352 3.78865C4.99359 3.87857 4.90366 3.97141 4.81373 4.06133C4.54395 4.33402 4.29156 4.59221 4.01307 4.83879C4.00727 4.84459 4.00437 4.84749 3.99857 4.85329C3.75779 5.09407 3.7955 5.32325 3.85352 5.49731C3.85642 5.50601 3.85932 5.51181 3.86222 5.52051C4.0856 6.05719 4.396 6.56776 4.88046 7.17696C5.75074 8.25031 6.66744 9.08288 7.67697 9.724C7.80172 9.80522 7.93516 9.86904 8.0599 9.93286C8.17594 9.99088 8.28327 10.046 8.379 10.1069C8.39061 10.1127 8.39931 10.1185 8.41092 10.1243C8.50665 10.1736 8.59948 10.1969 8.69231 10.1969C8.92439 10.1969 9.07523 10.0489 9.12455 9.99959L10.2095 8.91463C10.3778 8.74637 10.5605 8.65644 10.7404 8.65644C10.9609 8.65644 11.1407 8.79279 11.2538 8.91463L13.0031 10.661C13.3512 11.0091 13.3483 11.3862 12.9944 11.7547C12.8726 11.8852 12.7449 12.0099 12.6086 12.1405C12.4055 12.3378 12.1938 12.5408 12.0023 12.77C11.6687 13.1297 11.2713 13.298 10.7578 13.298C10.7085 13.298 10.6563 13.2951 10.6069 13.2922C9.65543 13.2312 8.77063 12.8599 8.10632 12.5437C6.30192 11.6705 4.718 10.4318 3.40387 8.85951C2.32182 7.55698 1.59368 6.34438 1.11212 5.04476C0.81332 4.247 0.700183 3.60588 0.746598 3.02279Z"
                                    fill="#807C75"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_526_4013">
                                    <rect width="14" height="14" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                              <span className="fw-semibold ">
                                {" "}
                                {data?.phone}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <ArrowForward sx={{ color: "var(--primary-color)" }} />
                    </div>
                  ))}
              </div>
            </div>
          )}
        </DialogContent>

        <div className="p-2 p-md-4 d-flex flex-column gap-2 ">
          <Button
            disabled={loading}
            id="confirm_and_create_clinical_note"
            style={{
              background: loading
                ? "var(--primary-accent-color)"
                : "var(--primary-color)",
              textTransform: "capitalize",
              fontSize: "16px",
            }}
            onClick={() => {
              handleClose();
              setCreateNewClient(true);
              setShowOptionalFields(false);
            }}
            className="font-inter w-100 rounded-3 d-flex align-items-center justify-content-center  fw-semibold p-2 py-2  p-md-3 text-white"
          >
            <AddOutlinedIcon />{" "}
            <span className="m-0 p-0">
              Create new {isAusDomain() ? "patient" : "client"} Profile
            </span>
          </Button>
        </div>
      </Dialog>

      <Dialog
        className="client-details-dialog"
        open={createNewClient}
        onClose={() => {
          setCreateNewClient(false);
          setShowOptionalFields(false);
          setClientDetails({
            firstName: "",
            middleName: "",
            lastName: "",
            email: "",
            phone: "",
            phone_code: isAusDomain() ? "+61-AU" : "", // Default to Australia if Australian domain
            age: "",
            sex: "",
            hisNumber: "",
            address: "",
            socialSecurity: "",
            country: currentUser?.Country,
            consultation: dayjs().format("YYYY-MM-DD"),
            state: "",
            dob: "",
          });
          setCountrySearchTerm("");
          setIsCountryDropdownOpen(false);
        }}
      >
        {/* <DialogTitle>
          <Paper
            component="form"
            sx={{
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              width: "100%",
              borderRadius: "10px",
              margin: "10px 0",
            }}
          >
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search by Client's Name"
            />
            <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
              <KeyboardVoiceOutlinedIcon />
            </IconButton>
          </Paper>
        </DialogTitle> */}
        <DialogContent className="p-2 p-md-4  rounded rounded-2">
          <DialogContentText
            className="d-flex flex-column gap-2 add-client-details align-items-center fw-semibold  lh-base "
            sx={{ fontSize: "18px" }}
          >
            <div
              className="p-3 rounded-3 border border-1"
              style={{ background: "#E6E6E9" }}
            >
              <DialogContentText
                className="d-flex justify-content-between align-items-center fw-semibold "
                sx={{ fontSize: "18px" }}
              >
                <span style={{ color: "#080807" }}>
                  Add New {isAusDomain() ? "Patient" : "Client"} Details
                </span>{" "}
                <IconButton
                  className=" "
                  onClick={() => {
                    setCreateNewClient(false);
                    setShowOptionalFields(false);
                    setClientDetails({
                      firstName: "",
                      middleName: "",
                      lastName: "",
                      email: "",
                      phone: "",
                      phone_code: isAusDomain() ? "+61-AU" : "",
                      age: "",
                      sex: "",
                      hisNumber: "",
                      address: "",
                      socialSecurity: "",
                      country: currentUser?.Country,
                      consultation: dayjs().format("YYYY-MM-DD"),
                      state: "",
                      dob: "",
                    });
                    setCountrySearchTerm("");
                    setIsCountryDropdownOpen(false);
                  }}
                >
                  <Close />
                </IconButton>
              </DialogContentText>
              <Grid className="" container spacing={2}>
                {/* First Name */}
                <Grid item xs={12} md={4}>
                  <div>
                    <p
                      className="text-black fw-semibold "
                      style={{ fontSize: "14px", margin: "0px" }}
                    >
                      First Name
                    </p>
                    <TextField
                      hiddenLabel
                      id="filled-hidden-label-small"
                      placeholder="First Name"
                      type="text"
                      // size="small"
                      fullWidth
                      value={clientDetails?.firstName || ""}
                      onChange={(e) =>
                        setClientDetails({
                          ...clientDetails,
                          firstName: e.target.value,
                        })
                      }
                    />
                  </div>
                </Grid>

                {/* Middle Name */}
                <Grid item xs={12} md={4}>
                  <div>
                    <p
                      className="text-black fw-semibold "
                      style={{ fontSize: "14px", margin: "0px" }}
                    >
                      Middle Name
                    </p>
                    <TextField
                      hiddenLabel
                      id="filled-hidden-label-small"
                      placeholder="Middle Name"
                      type="text"
                      // size="small"
                      fullWidth
                      value={clientDetails?.middleName || ""}
                      onChange={(e) =>
                        setClientDetails({
                          ...clientDetails,
                          middleName: e.target.value,
                        })
                      }
                    />
                  </div>
                </Grid>

                {/* Last Name */}
                <Grid item xs={12} md={4}>
                  <div>
                    <p
                      className="text-black fw-semibold "
                      style={{ fontSize: "14px", margin: "0px" }}
                    >
                      Last Name
                    </p>
                    <TextField
                      hiddenLabel
                      id="filled-hidden-label-small"
                      placeholder="Last Name"
                      type="text"
                      // size="small"
                      fullWidth
                      value={clientDetails?.lastName || ""}
                      onChange={(e) =>
                        setClientDetails({
                          ...clientDetails,
                          lastName: e.target.value,
                        })
                      }
                    />
                  </div>
                </Grid>

                {/* Email Address */}
                <Grid item xs={12} md={6}>
                  <div>
                    <p
                      className="text-black fw-semibold "
                      style={{ fontSize: "14px", margin: "0px" }}
                    >
                      Email Address&nbsp;
                      <Tooltip
                        arrow
                        title={
                          <p
                            className="m-0"
                            style={{ fontSize: "12px", color: "white" }}
                          >
                            {` Please note that no communications will be sent to the ${isAusDomain() ? "patient" : "client"
                              }'s email address unless authorized or sent by you.`}
                          </p>
                        }
                        placement="top-start"
                        componentsProps={{
                          tooltip: {
                            sx: {
                              bgcolor: "common.black",
                              "& .MuiTooltip-arrow": {
                                color: "common.black",
                              },
                              color: "common.white",
                              padding: "10px",
                            },
                          },
                        }}
                      >
                        <InfoOutlined
                          sx={{ fontSize: "16px", color: "black" }}
                        />
                      </Tooltip>
                    </p>
                    <TextField
                      hiddenLabel
                      id="filled-hidden-label-small"
                      placeholder="Email Address..."
                      fullWidth
                      type="email"
                      value={clientDetails?.email || ""}
                      onChange={(e) =>
                        setClientDetails({
                          ...clientDetails,
                          email: e.target.value,
                        })
                      }
                    />
                  </div>
                </Grid>

                {/* Sex */}
                <Grid item xs={12} md={6}>
                  <div className="d-flex gap-2">
                    <div style={{ flex: 1 }}>
                      <p
                        className="text-black fw-semibold "
                        style={{ fontSize: "14px", margin: "0px" }}
                      >
                        Sex
                      </p>
                      <TextField
                        hiddenLabel
                        id="filled-hidden-label-small"
                        select
                        // label="Sex"
                        placeholder="Sex"
                        value={clientDetails.sex || ""}
                        onChange={handleGenderChange}
                        fullWidth
                        // size="small"
                        sx={{ width: "100%" }}
                      >
                        {genderOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </div>
                  </div>
                </Grid>

                {/* Phone Number */}
                <Grid item xs={12} md={6}>
                  <div>
                    <p
                      className="text-black fw-semibold "
                      style={{ fontSize: "14px", margin: "0px" }}
                    >
                      Phone Number
                    </p>
                    <div className="d-flex gap-2">
                      <div
                        ref={countryDropdownRef}
                        style={{ width: "75px", position: "relative" }}
                      >
                        <TextField
                          fullWidth
                          hiddenLabel
                          id="filled-hidden-label-small"
                          value={getPhoneCodeFromValue(clientDetails?.phone_code) || "+61"}
                          placeholder="Code  ▼"
                          onClick={() => {
                            setIsCountryDropdownOpen(!isCountryDropdownOpen);
                            setCountrySearchTerm("");
                          }}
                          InputProps={{
                            readOnly: true,
                            style: {
                              cursor: "pointer",
                            },
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              height: "40px",
                              borderRadius: "0px",
                              "&:hover fieldset": {
                                borderColor: "var(--primary-color)",
                              },
                            },
                          }}
                        />

                        {isCountryDropdownOpen && (
                          <div
                            style={{
                              position: "absolute",
                              top: "calc(100% + 2px)",
                              left: 0,
                              right: 0,
                              backgroundColor: "white",
                              zIndex: 1000,
                              maxHeight: "280px",
                              overflow: "hidden",
                              minWidth: "180px",
                            }}
                          >
                            {/* Search Input */}
                            <div
                              style={{
                                padding: "8px 12px",
                                borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                                position: "sticky",
                                top: 0,
                                backgroundColor: "white",
                                zIndex: 1,
                              }}
                            >
                              <TextField
                                size="small"
                                placeholder="Search countries..."
                                fullWidth
                                value={countrySearchTerm}
                                onChange={(e) => {
                                  setCountrySearchTerm(e.target.value);
                                }}
                                autoFocus
                                InputProps={{
                                  style: {
                                    fontSize: "13px",
                                    backgroundColor: "#f8f9fa",
                                    height: "32px",
                                  },
                                }}
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    height: "32px",
                                    "& fieldset": {
                                      borderColor: "rgba(0, 0, 0, 0.23)",
                                    },
                                    "&:hover fieldset": {
                                      borderColor: "var(--primary-color)",
                                    },
                                    "&.Mui-focused fieldset": {
                                      borderColor: "var(--primary-color)",
                                    },
                                  },
                                }}
                              />
                            </div>

                            {/* Countries List */}
                            <div
                              style={{
                                maxHeight: "220px",
                                overflowY: "auto",
                              }}
                              className="custom-scrollbar"
                            >
                              <style jsx>{`
                                .custom-scrollbar::-webkit-scrollbar {
                                  width: 6px;
                                }
                                .custom-scrollbar::-webkit-scrollbar-track {
                                  background: #f1f1f1;
                                  border-radius: 3px;
                                }
                                .custom-scrollbar::-webkit-scrollbar-thumb {
                                  background: #c1c1c1;
                                  border-radius: 3px;
                                }
                                .custom-scrollbar::-webkit-scrollbar-thumb:hover {
                                  background: #a8a8a8;
                                }
                              `}</style>
                              {getFilteredCountries().length === 0 ? (
                                <div
                                  style={{
                                    padding: "20px",
                                    textAlign: "center",
                                    color: "rgba(0, 0, 0, 0.6)",
                                    fontSize: "14px",
                                    fontStyle: "italic",
                                  }}
                                >
                                  No countries found
                                </div>
                              ) : (
                                getFilteredCountries().map((country, index) => (
                                  <div
                                    key={`${country.phone_code}-${country.iso2}`}
                                    style={{
                                      padding: "8px 12px",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                      borderBottom:
                                        index ===
                                          getFilteredCountries().length - 1
                                          ? "none"
                                          : "1px solid rgba(0, 0, 0, 0.08)",
                                      transition: "background-color 0.15s ease",
                                      fontSize: "13px",
                                      minHeight: "36px",
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.backgroundColor =
                                        "rgba(25, 118, 210, 0.08)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.backgroundColor =
                                        "transparent";
                                    }}
                                    onClick={() => {
                                      setClientDetails({
                                        ...clientDetails,
                                        phone_code: `${country.phone_code}-${country.iso2}`,
                                      });
                                      setIsCountryDropdownOpen(false);
                                      setCountrySearchTerm("");
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontWeight: "600",
                                        minWidth: "35px",
                                        color: "var(--primary-color, #1976d2)",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {country.phone_code}
                                    </span>
                                    <span
                                      style={{
                                        color: "rgba(0, 0, 0, 0.87)",
                                        fontSize: "13px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        flex: 1,
                                        lineHeight: "1.3",
                                      }}
                                    >
                                      {country.name}
                                    </span>
                                  </div>
                                ))
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                      <div style={{ flex: 1 }}>
                        <TextField
                          hiddenLabel
                          id="filled-hidden-label-small"
                          fullWidth
                          placeholder="Phone Number"
                          value={clientDetails?.phone}
                          onChange={(e) => {
                            const inputPhoneNumber = e.target.value.replace(
                              /\D/g,
                              ""
                            ); // Remove non-digit characters
                            const formattedPhoneNumber =
                              inputPhoneNumber.substring(0, 10); // Take first 10 digits
                            setClientDetails({
                              ...clientDetails,
                              phone: formattedPhoneNumber,
                            });
                          }}
                          InputProps={{
                            style: {
                              height: "40px",
                            },
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              height: "40px",
                              borderRadius: "0px",
                            },
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Grid>

                {/* Date of Birth */}
                <Grid item xs={12} md={6}>
                  <div>
                    <p
                      className="text-black fw-semibold "
                      style={{ fontSize: "14px", margin: "0px" }}
                    >
                      Date of Birth
                    </p>
                    <div className="datePicker">
                      {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={["DatePicker"]} sx={{ p: 0 }}>
                        <DatePicker
                          fullWidth
                          sx={{ background: "white" }}
                          // If you need a label, uncomment the next line
                          // label="Consultation Date"
                          value={dayjs(clientDetails.consultation)}
                          onChange={handleConsultationDateChange}
                          maxDate={dayjs()} // Sets today as the maximum date selectable
                          renderInput={(params) => <TextField {...params} />}
                        />
                      </DemoContainer>
                    </LocalizationProvider> */}
                      <input
                        type="date"
                        className="w-100 rounded-2 border p-1"
                        max={dayjs().format("YYYY-MM-DD")}
                        value={clientDetails.dob}
                        onChange={handleDobChange}
                      />
                    </div>

                    {/* <TextField
                    hiddenLabel
                    id="filled-hidden-label-small"
                    placeholder="mm"
                    // size="small"
                    onChange={(e) => setClientDetails({ ...clientDetails, name: e.target.value })}
                  /> */}
                  </div>
                </Grid>

                <Grid item xs={12} md={6}>
                  <div>
                    <p
                      className="text-black fw-semibold "
                      style={{ fontSize: "14px", margin: "0px" }}
                    >
                      Country
                    </p>
                    <TextField
                      fullWidth
                      hiddenLabel
                      id="filled-hidden-label-small"
                      select
                      // label="Country"

                      placeholder="Country"
                      value={clientDetails.country || ""}
                      onChange={handleCountryChange} // Handle the onChange event
                      // size="small"F
                      sx={{ width: "100%" }}
                    >
                      {countryList?.map((option) => (
                        <MenuItem key={option.code} value={option.name}>
                          {option.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>
                </Grid>

                {/* Note about required fields */}
                <Grid item xs={12}>
                  <div>
                    <p
                      className="text-muted fw-normal"
                      style={{
                        fontSize: "12px",
                        margin: "0px",
                        fontStyle: "italic",
                      }}
                    >
                      * Either Email Address or Phone Number is required
                    </p>
                  </div>
                </Grid>
                {!showOptionalFields && (
                  <Grid item xs={12} md={6}>
                    <div>
                      <p
                        className="mb-1 fw-semibold "
                        style={{
                          fontSize: "14px",
                          margin: "0px",
                          color: "#E6E6E9",
                        }}
                      >
                        .
                      </p>
                      <Button
                        style={{
                          border: "1px solid #D0D5DD",
                          textTransform: "capitalize",
                          boxShadow: "none",
                        }}
                        onClick={() => setShowOptionalFields(true)}
                        className=" d-flex gap-2 text-black"
                        fullWidth
                      >
                        <span>
                          Add more details{" "}
                          <span style={{ color: "#667085" }}>(Optional)</span>{" "}
                        </span>{" "}
                        <Add />
                      </Button>
                    </div>
                  </Grid>
                )}
              </Grid>
            </div>
            <div
              style={{
                display: showOptionalFields ? "block" : "none",
              }}
              className="p-3 rounded-3 border border-1"
            >
              <p
                className="text-black mb-3 fw-semibold "
                style={{ fontSize: "14px", margin: "0px" }}
              >
                Optional Details
              </p>
              <Grid className="" container spacing={2}>
                <Grid item xs={12} md={6}>
                  <div>
                    <p
                      className="text-black fw-semibold "
                      style={{ fontSize: "14px", margin: "0px" }}
                    >
                      Consultation Date
                    </p>
                    <div className="datePicker">
                      {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={["DatePicker"]} sx={{ p: 0 }}>
                        <DatePicker
                          fullWidth
                          sx={{ background: "white" }}
                          // If you need a label, uncomment the next line
                          // label="Consultation Date"
                          value={dayjs(clientDetails.consultation)}
                          onChange={handleConsultationDateChange}
                          maxDate={dayjs()} // Sets today as the maximum date selectable
                          renderInput={(params) => <TextField {...params} />}
                        />
                      </DemoContainer>
                    </LocalizationProvider> */}
                      <input
                        type="date"
                        className="w-100 rounded-2 border p-1"
                        max={dayjs().format("YYYY-MM-DD")}
                        value={clientDetails.consultation}
                        onChange={handleConsultationDateChange}
                      />
                    </div>

                    {/* <TextField
                    hiddenLabel
                    id="filled-hidden-label-small"
                    placeholder="mm"
                    // size="small"
                    onChange={(e) => setClientDetails({ ...clientDetails, name: e.target.value })}
                  /> */}
                  </div>
                </Grid>{" "}
                {!isAusDomain() && (
                  <Grid item xs={12} md={6}>
                    <div>
                      <p
                        className="text-black fw-semibold "
                        style={{ fontSize: "14px", margin: "0px" }}
                      >
                        HIS Number
                      </p>
                      <TextField
                        fullWidth
                        hiddenLabel
                        id="filled-hidden-label-small"
                        placeholder="HIS Number"
                        value={clientDetails?.hisNumber || ""}
                        // size="small"
                        onChange={(e) =>
                          setClientDetails({
                            ...clientDetails,
                            hisNumber: e.target.value,
                          })
                        }
                      />
                    </div>
                  </Grid>
                )}
                <Grid item xs={12} md={6}>
                  <div>
                    <p
                      className="text-black fw-semibold "
                      style={{ fontSize: "14px", margin: "0px" }}
                    >
                      Address
                    </p>
                    <TextField
                      fullWidth
                      hiddenLabel
                      id="filled-hidden-label-small"
                      placeholder="Address"
                      value={clientDetails?.address || ""}
                      // size="small"
                      onChange={(e) =>
                        setClientDetails({
                          ...clientDetails,
                          address: e.target.value,
                        })
                      }
                    />
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <div>
                    <p
                      className="text-black fw-semibold "
                      style={{ fontSize: "14px", margin: "0px" }}
                    >
                      {isAusDomain()
                        ? "Medicare Number / IHI Number"
                        : "Social Security"}
                    </p>
                    <TextField
                      fullWidth
                      hiddenLabel
                      id="filled-hidden-label-small"
                      placeholder={
                        isAusDomain()
                          ? "Medicare Number / IHI Number"
                          : "Social Security"
                      }
                      // size="small"
                      value={clientDetails?.socialSecurity || ""}
                      onChange={(e) =>
                        setClientDetails({
                          ...clientDetails,
                          socialSecurity: e.target.value,
                        })
                      }
                    />
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <div>
                    <p
                      className="text-black fw-semibold "
                      style={{ fontSize: "14px", margin: "0px" }}
                    >
                      State
                    </p>

                    <TextField
                      fullWidth
                      hiddenLabel
                      id="filled-hidden-label-small"
                      select
                      // label="Country"
                      value={clientDetails.state || ""}
                      onChange={handleStateChange} // Handle the onChange event
                      // size="small"
                      sx={{ width: "100%" }}
                    >
                      {stateList?.map((option) => (
                        <MenuItem key={option.code} value={option.name}>
                          {option.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>
                </Grid>
              </Grid>
            </div>
          </DialogContentText>
        </DialogContent>

        <div className="p-2 p-md-4 d-flex flex-column gap-2 ">
          <Button
            disabled={loading}
            id="confirm_and_create_clinical_note"
            style={{
              border: "1px solid #D0D5DD",
              color: "#344054",
              textTransform: "capitalize",
              fontSize: "16px",
            }}
            className="font-inter d-none w-100 rounded-3 d-flex align-items-center justify-content-center  fw-semibold p-2 py-2  p-md-3 "
          >
            <span className="m-0 p-0">Detect Automatically From Document</span>
          </Button>
          <Button
            disabled={loading}
            id="confirm_and_create_clinical_note"
            style={{
              // border: "1px solid var(--primary-color)",
              background: loading
                ? "var(--primary-accent-color)"
                : "var(--primary-color)",
              textTransform: "capitalize",
              fontSize: "16px",
            }}
            onClick={confirmAndCreateSession}
            className="font-inter w-100 rounded-3 d-flex align-items-center justify-content-center  fw-semibold p-2 py-2  p-md-3 text-white"
          >
            <span className="m-0 p-0">Confirm and create clinical note</span>{" "}
            <ArrowRightAltIcon />
          </Button>
        </div>
      </Dialog>

      {/* {loading && (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            height: "100vh",
            width: "100vw",
            zIndex: "1000000",
          }}
          className="d-flex justify-content-center align-items-center"
        >
          <CircularProgress sx={{ color: "var(--primary-color)" }} />
        </div>
      )} */}

    </div>
  );
};

export default CreateClinicalNote;
